import React from 'react';
import {StringParam, useQueryParam} from 'use-query-params';
import { graphql, useStaticQuery, navigate } from 'gatsby';

export default function GeneralSearchForm(): React.JSX.Element {
  const [searchTerm, setSearchTerm] = useQueryParam('q', StringParam);

  const handleSubmit = (event) => {
    event.preventDefault();
    const searchParam = event.target.elements.q.value;
    navigate(`?q=${searchParam}`);
  };

  return (
    <form className="vl-form" onSubmit={handleSubmit}>
      <label className="vl-form__label" htmlFor="q">Zoekterm</label>
      <div className="vl-input-field--inline">
        <input
          className="vl-input-field vl-input-field__input"
          type="search"
          id="q"
          name="q"
          defaultValue={searchTerm}
          placeholder="Zoeken"
        />

        <button className="vl-input-field__submit vl-button" type="submit">
          <i className="vl-vi vl-vi-magnifier" aria-hidden="true"></i>
          <span className="vl-u-visually-hidden">Zoeken</span>
        </button>
      </div>
    </form>
  );
}